import { InvitesTable } from "@/components/invites-table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UsersTable } from "@/components/users-table";
import { createFileRoute } from "@tanstack/react-router";
import { debounce, parseAsString, parseAsStringEnum, useQueryStates } from "nuqs";
import { useAdminUsers } from "../-admin-context";

export const Route = createFileRoute("/dashboard/admin/users/")({
  head: () => ({
    meta: [
      {
        title: "GetHandle",
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const usersResource = useAdminUsers();

  const [filters, setFilters] = useQueryStates(
    {
      search: parseAsString.withDefault(""),
      type: parseAsStringEnum(["all", "admin", "manager", "support", "customer"]).withDefault(
        "all",
      ),
    },
    { history: "replace" },
  );

  const handleSearchChange = (value: string) => {
    setFilters(
      { search: value },
      {
        limitUrlUpdates: value === "" ? undefined : debounce(300),
      },
    );
  };

  const handleTypeChange = (value: string) => {
    setFilters({ type: value as "all" | "admin" | "manager" | "support" | "customer" });
  };

  return (
    <div className="container mx-auto p-1 sm:p-6">
      <Tabs defaultValue="users" className="w-full">
        <TabsList>
          <TabsTrigger value="users">Users</TabsTrigger>
          <TabsTrigger value="invites">Invites</TabsTrigger>
        </TabsList>
        <TabsContent value="users">
          <UsersTable
            usersResource={usersResource}
            searchValue={filters.search}
            onSearchChange={handleSearchChange}
            typeFilter={filters.type}
            onTypeFilterChange={handleTypeChange}
          />
        </TabsContent>
        <TabsContent value="invites">
          <InvitesTable />
        </TabsContent>
      </Tabs>
    </div>
  );
}
